import React, { createContext, useEffect, useState } from "react";
import { noop } from "@catchoftheday/cg-components";
import {
  CustomerQuery,
  useCustomerQuery,
} from "@common-vendors/generated/graphql";

export const customerInitialState = null;

type ContextData = {
  data: CustomerQuery["customer"];
  loggedIn: boolean;
  loading: boolean;
  showLoginModal: boolean;
  setShowLoginModal: React.Dispatch<React.SetStateAction<boolean>>;
};

export const CustomerContext = createContext<ContextData>({
  data: customerInitialState,
  loggedIn: false,
  loading: false,
  showLoginModal: false,
  setShowLoginModal: noop,
});

export const CustomerContextProvider: React.FC = ({ children }) => {
  const { data, loading, refetch } = useCustomerQuery({ ssr: false });
  const [showLoginModal, setShowLoginModal] = useState(false);
  const customerData: ContextData["data"] = !data?.customer
    ? customerInitialState
    : data.customer;

  useEffect(() => {
    let mounted = true;
    if (mounted) {
      refetch();
    }

    return () => {
      mounted = false;
    };
  }, [refetch]);

  return (
    <CustomerContext.Provider
      value={{
        data: customerData,
        loggedIn: !!data?.customer,
        loading: loading,
        showLoginModal,
        setShowLoginModal,
      }}
    >
      {children}
    </CustomerContext.Provider>
  );
};
